import { render, staticRenderFns } from "./PasoFinalCompra.vue?vue&type=template&id=6f2cbe34"
import script from "./PasoFinalCompra.vue?vue&type=script&lang=js"
export * from "./PasoFinalCompra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports